// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../../node_modules/rescript/lib/es6/list.js";
import * as Award from "../types/Award.bs.js";
import * as RnrUrl from "../types/RnrUrl.bs.js";
import * as RewardType from "../types/RewardType.bs.js";
import * as Belt_Option from "../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Json_decode from "../../../../../node_modules/@glennsl/bs-json/src/Json_decode.bs.js";
import * as RewardStatus from "../types/RewardStatus.bs.js";
import * as RewardCategory from "../types/RewardCategory.bs.js";
import * as RewardMilestone from "../types/RewardMilestone.bs.js";
import * as VehicleCategory from "../types/VehicleCategory.bs.js";
import * as DateTime$Catalyst from "../../../../../node_modules/@porterin/catalyst/src/utils/DateTime.bs.js";
import * as ErrorUtils$Catalyst from "../../../../../node_modules/@porterin/catalyst/src/utils/ErrorUtils.bs.js";
import * as OptionTypeUtils$Catalyst from "../../../../../node_modules/@porterin/catalyst/src/utils/OptionTypeUtils.bs.js";

function slabsDecoder(json) {
  return {
          orderCount: Json_decode.field("order_count", Json_decode.$$int, json),
          points: Json_decode.field("points", Json_decode.$$int, json)
        };
}

function getDecodedComputer(json) {
  return {
          computerType: RewardType.fromString(Json_decode.field("type", Json_decode.string, json)),
          minRating: Json_decode.optional((function (param) {
                  return Json_decode.field("min_rating", Json_decode.$$int, param);
                }), json),
          points: Json_decode.optional((function (param) {
                  return Json_decode.field("points", Json_decode.$$int, param);
                }), json),
          windowStartMins: Json_decode.optional((function (param) {
                  return Json_decode.field("window_start_mins", Json_decode.$$int, param);
                }), json),
          windowEndMins: Json_decode.optional((function (param) {
                  return Json_decode.field("window_end_mins", Json_decode.$$int, param);
                }), json),
          perHourPoints: Json_decode.optional((function (param) {
                  return Json_decode.field("per_hour_points", Json_decode.$$int, param);
                }), json),
          slabs: Json_decode.optional((function (param) {
                  return Json_decode.field("slabs", (function (param) {
                                return Json_decode.list(slabsDecoder, param);
                              }), param);
                }), json)
        };
}

function getTypedComputer(computer) {
  var match = computer.computerType;
  switch (match) {
    case /* OrderRating */0 :
        return {
                TAG: /* OrderRatingComputer */0,
                _0: {
                  computerType: computer.computerType,
                  minRating: Belt_Option.getWithDefault(computer.minRating, 0),
                  points: Belt_Option.getWithDefault(computer.points, 0)
                }
              };
    case /* LoginHours */1 :
        return {
                TAG: /* LoginHourComputer */1,
                _0: {
                  computerType: computer.computerType,
                  windowStartMins: Belt_Option.getWithDefault(computer.windowStartMins, 0),
                  windowEndMins: Belt_Option.getWithDefault(computer.windowEndMins, 0),
                  perHourPoints: Belt_Option.getWithDefault(computer.perHourPoints, 0)
                }
              };
    case /* OrderFulfillment */2 :
        var slabs = computer.slabs;
        return {
                TAG: /* OrderFulfillmentComputer */2,
                _0: {
                  computerType: computer.computerType,
                  slabs: slabs !== undefined ? slabs : ErrorUtils$Catalyst.raiseError("RnrStateMapper.re", "No computer slabs provided", "")
                }
              };
    
  }
}

function computerDecoder(json) {
  return getTypedComputer(getDecodedComputer(json));
}

function getFuelAward(json) {
  return {
          TAG: /* Fuel */0,
          _0: {
            awardedAt: DateTime$Catalyst.fromTimeStamp(Json_decode.field("awarded_at", Json_decode.$$int, json)),
            fuelQuantity: Json_decode.field("fuel_quantity", Json_decode.$$int, json),
            amount: Json_decode.field("amount", Json_decode.$$int, json)
          }
        };
}

function getRnrSponser(json) {
  return {
          name: Json_decode.field("name", Json_decode.string, json),
          display_name: Json_decode.field("display_name", Json_decode.string, json),
          logo_url: Json_decode.field("logo_url", (function (param) {
                  return Json_decode.optional(Json_decode.string, param);
                }), json)
        };
}

function getTextRedemption(json) {
  return Json_decode.field("steps", (function (param) {
                return Json_decode.list(Json_decode.string, param);
              }), json);
}

function getVideoRedemption(json) {
  return RnrUrl.createUrl(Json_decode.field("video_url", Json_decode.string, json));
}

function getRedemtionDetails(json) {
  var redemtionType = Json_decode.field("type", Json_decode.string, json);
  switch (redemtionType) {
    case "TEXT" :
        return {
                TAG: /* Text */0,
                _0: getTextRedemption(json)
              };
    case "VIDEO" :
        return {
                TAG: /* Video */1,
                _0: getVideoRedemption(json)
              };
    default:
      return ErrorUtils$Catalyst.raiseError("RnrStateMapper.re", "No redemtion types provided", "");
  }
}

function getCtaContent(json) {
  return {
          link: RnrUrl.createUrl(Json_decode.field("link", Json_decode.string, json)),
          name: Json_decode.field("name", Json_decode.string, json),
          description: Json_decode.field("description", Json_decode.string, json)
        };
}

function getCouponScheme(json) {
  return {
          summary: Json_decode.field("summary", Json_decode.string, json),
          short_description: Json_decode.field("short_description", Json_decode.string, json),
          rnr_sponsor: Json_decode.field("rnr_sponsor", getRnrSponser, json),
          scheme_details: Json_decode.field("scheme_details", (function (param) {
                  return Json_decode.list(Json_decode.string, param);
                }), json),
          redemption_details: Json_decode.field("redemption_detail", getRedemtionDetails, json),
          terms_and_conditions: Json_decode.field("terms_and_conditions", (function (param) {
                  return Json_decode.list(Json_decode.string, param);
                }), json),
          claim_cta_content: Json_decode.field("claim_actions", (function (param) {
                  return Json_decode.list(getCtaContent, param);
                }), json)
        };
}

function getCouponAward(json) {
  return {
          TAG: /* Coupon */8,
          _0: {
            coupon_code: Json_decode.field("coupon_code", Json_decode.string, json),
            expiry_date: DateTime$Catalyst.fromString("YYYY-MM-DD", Json_decode.field("expiry_date", Json_decode.string, json)),
            coupon_scheme: Json_decode.field("coupon_scheme", getCouponScheme, json),
            awardedAt: DateTime$Catalyst.fromTimeStamp(Json_decode.field("awarded_at", Json_decode.$$int, json))
          }
        };
}

function getPremiumnessAward(json) {
  return {
          TAG: /* Premiumness */1,
          _0: {
            awardedAt: DateTime$Catalyst.fromTimeStamp(Json_decode.field("awarded_at", Json_decode.$$int, json)),
            startDate: DateTime$Catalyst.fromString("YYYY-MM-DD", Json_decode.field("start_date", Json_decode.string, json)),
            endDate: DateTime$Catalyst.fromString("YYYY-MM-DD", Json_decode.field("end_date", Json_decode.string, json)),
            acceptAdvantage: Json_decode.field("accept_advantage", Json_decode.$$int, json)
          }
        };
}

function getRewardMultiplierAward(json) {
  return {
          TAG: /* RewardMultiplier */2,
          _0: {
            awardedAt: DateTime$Catalyst.fromTimeStamp(Json_decode.field("awarded_at", Json_decode.$$int, json)),
            startDate: DateTime$Catalyst.fromString("YYYY-MM-DD", Json_decode.field("start_date", Json_decode.string, json)),
            endDate: DateTime$Catalyst.fromString("YYYY-MM-DD", Json_decode.field("end_date", Json_decode.string, json)),
            multiplier: Json_decode.field("multiplier", Json_decode.$$float, json)
          }
        };
}

function getNoAward(json) {
  return {
          TAG: /* NoAward */3,
          _0: {
            awardedAt: DateTime$Catalyst.fromTimeStamp(Json_decode.field("awarded_at", Json_decode.$$int, json))
          }
        };
}

function getMonetaryAward(json) {
  return {
          TAG: /* Monetary */4,
          _0: {
            awardedAt: DateTime$Catalyst.fromTimeStamp(Json_decode.field("awarded_at", Json_decode.$$int, json)),
            amount: Json_decode.field("amount", Json_decode.$$int, json)
          }
        };
}

function getInsuranceAward(json) {
  return {
          TAG: /* Insurance */5,
          _0: {
            awardedAt: DateTime$Catalyst.fromTimeStamp(Json_decode.field("awarded_at", Json_decode.$$int, json)),
            endDate: DateTime$Catalyst.fromString("YYYY-MM-DD", Json_decode.field("end_date", Json_decode.string, json)),
            price: Json_decode.optional((function (param) {
                    return Json_decode.field("price", Json_decode.$$int, param);
                  }), json),
            discount: Json_decode.optional((function (param) {
                    return Json_decode.field("discount", Json_decode.$$int, param);
                  }), json),
            benefit_type: Award.fromStringInsuranceAwardType(Json_decode.field("benefit_type", Json_decode.string, json))
          }
        };
}

function getDistributionCeremonyAward(json) {
  return {
          TAG: /* DistributionCeremony */6,
          _0: {
            awardedAt: DateTime$Catalyst.fromTimeStamp(Json_decode.field("awarded_at", Json_decode.$$int, json)),
            awardType: Json_decode.field("type", Json_decode.string, json)
          }
        };
}

function getFinalAward(json) {
  return {
          TAG: /* Final */7,
          _0: {
            awardedAt: DateTime$Catalyst.fromTimeStamp(Json_decode.field("awarded_at", Json_decode.$$int, json)),
            awardType: Json_decode.field("type", Json_decode.string, json)
          }
        };
}

function awardDecoder(json) {
  var awardType = Json_decode.field("type", Json_decode.string, json);
  switch (awardType) {
    case "COUPON_AWARD" :
        return getCouponAward(json);
    case "DISTRIBUTION_CEREMONY" :
        return getDistributionCeremonyAward(json);
    case "FINAL_AWARD" :
        return getFinalAward(json);
    case "FUEL" :
        return getFuelAward(json);
    case "INSURANCE" :
        return getInsuranceAward(json);
    case "MONETARY" :
        return getMonetaryAward(json);
    case "NO_AWARD" :
        return getNoAward(json);
    case "PREMIUM" :
        return getPremiumnessAward(json);
    case "REWARD_MULTIPLIER" :
        return getRewardMultiplierAward(json);
    default:
      return getNoAward(json);
  }
}

function cycleCategoryAggDecoder(json) {
  return {
          name: RewardCategory.fromString(Json_decode.field("category", Json_decode.string, json)),
          points: Json_decode.field("points", Json_decode.$$int, json),
          computers: Json_decode.field("computers", (function (param) {
                  return Json_decode.list(computerDecoder, param);
                }), json)
        };
}

function milestoneDecoder(json) {
  return {
          name: RewardMilestone.fromString(Json_decode.field("name", Json_decode.string, json)),
          points: Json_decode.field("points", Json_decode.$$int, json),
          award: Json_decode.optional((function (param) {
                  return Json_decode.field("award", awardDecoder, param);
                }), json)
        };
}

function rnrCycleDecoder(json) {
  return {
          startDate: Json_decode.field("start_date", Json_decode.string, json),
          endDate: Json_decode.field("end_date", Json_decode.string, json)
        };
}

function dailyRewardsDecoder(json) {
  return {
          entitlementDate: DateTime$Catalyst.fromString("YYYY-MM-DD", Json_decode.field("entitlement_date", Json_decode.string, json)),
          id: Json_decode.field("id", Json_decode.$$int, json),
          rewardType: RewardType.fromString(Json_decode.field("type", Json_decode.string, json)),
          points: Json_decode.field("points", Json_decode.$$int, json),
          status: RewardStatus.fromString(Json_decode.field("status", Json_decode.string, json)),
          category: RewardCategory.fromString(Json_decode.field("category", Json_decode.string, json)),
          expiryTime: Json_decode.field("expiry_ts", Json_decode.$$int, json),
          qualifiedOrders: Json_decode.optional((function (param) {
                  return Json_decode.field("qualified_order_count", Json_decode.$$int, param);
                }), json),
          completedOrders: Json_decode.optional((function (param) {
                  return Json_decode.field("completed_order_count", Json_decode.$$int, param);
                }), json),
          loginHours: Json_decode.optional((function (param) {
                  return Json_decode.field("login_hours", Json_decode.$$float, param);
                }), json),
          driverCancelledCount: Json_decode.optional((function (param) {
                  return Json_decode.field("driver_cancelled_count", Json_decode.$$int, param);
                }), json),
          completedCount: Json_decode.optional((function (param) {
                  return Json_decode.field("completed_count", Json_decode.$$int, param);
                }), json)
        };
}

function orderRatingRewardsDecoder(reward) {
  return {
          entitlementDate: reward.entitlementDate,
          id: reward.id,
          rewardType: reward.rewardType,
          points: reward.points,
          status: reward.status,
          category: reward.category,
          expiryTime: reward.expiryTime,
          qualifiedOrders: OptionTypeUtils$Catalyst.getIntFrmOptionalTypeStrict(reward.qualifiedOrders),
          completedOrders: OptionTypeUtils$Catalyst.getIntFrmOptionalTypeStrict(reward.completedOrders)
        };
}

function loginHourRewardsDecoder(reward) {
  return {
          entitlementDate: reward.entitlementDate,
          id: reward.id,
          rewardType: reward.rewardType,
          points: reward.points,
          status: reward.status,
          category: reward.category,
          expiryTime: reward.expiryTime,
          loginHours: OptionTypeUtils$Catalyst.getFloatFrmOptionalTypeStrict(reward.loginHours)
        };
}

function orderFulfillmentRewardsDecoder(reward) {
  return {
          entitlementDate: reward.entitlementDate,
          id: reward.id,
          rewardType: reward.rewardType,
          points: reward.points,
          status: reward.status,
          category: reward.category,
          expiryTime: reward.expiryTime,
          completedOrders: OptionTypeUtils$Catalyst.getIntFrmOptionalTypeStrict(reward.completedCount),
          driverCancelledCount: OptionTypeUtils$Catalyst.getIntFrmOptionalTypeStrict(reward.driverCancelledCount)
        };
}

function execute(json) {
  var dailyRewardList = Json_decode.field("rewards", (function (param) {
          return Json_decode.list(dailyRewardsDecoder, param);
        }), json);
  var getRewardList = function (category) {
    return List.filter(function (reward) {
                  return reward.category === category;
                })(dailyRewardList);
  };
  var customerExperienceRewardList = List.map(orderRatingRewardsDecoder, getRewardList(/* CustomerService */0));
  var loginHourRewardList = List.map(loginHourRewardsDecoder, getRewardList(/* LoginActivity */1));
  var orderFulfillmentRewardList = List.map(orderFulfillmentRewardsDecoder, getRewardList(/* OrderFulfillment */2));
  return {
          cycleCategoryAgg: Json_decode.field("cycle_category_aggregates", (function (param) {
                  return Json_decode.list(cycleCategoryAggDecoder, param);
                }), json),
          dailyRewards: {
            orderRatingRewards: customerExperienceRewardList,
            loginHourRewards: loginHourRewardList,
            orderFulfillmentRewards: orderFulfillmentRewardList
          },
          milestones: Json_decode.field("milestones", (function (param) {
                  return Json_decode.list(milestoneDecoder, param);
                }), json),
          rnrCycle: Json_decode.field("rnr_cycle", rnrCycleDecoder, json),
          vehicleCategory: VehicleCategory.fromString(Json_decode.field("vehicle_category", Json_decode.string, json))
        };
}

var RnrReport = {
  slabsDecoder: slabsDecoder,
  getDecodedComputer: getDecodedComputer,
  getTypedComputer: getTypedComputer,
  computerDecoder: computerDecoder,
  getFuelAward: getFuelAward,
  getRnrSponser: getRnrSponser,
  getTextRedemption: getTextRedemption,
  getVideoRedemption: getVideoRedemption,
  getRedemtionDetails: getRedemtionDetails,
  getCtaContent: getCtaContent,
  getCouponScheme: getCouponScheme,
  getCouponAward: getCouponAward,
  getPremiumnessAward: getPremiumnessAward,
  getRewardMultiplierAward: getRewardMultiplierAward,
  getNoAward: getNoAward,
  getMonetaryAward: getMonetaryAward,
  getInsuranceAward: getInsuranceAward,
  getDistributionCeremonyAward: getDistributionCeremonyAward,
  getFinalAward: getFinalAward,
  awardDecoder: awardDecoder,
  cycleCategoryAggDecoder: cycleCategoryAggDecoder,
  milestoneDecoder: milestoneDecoder,
  rnrCycleDecoder: rnrCycleDecoder,
  dailyRewardsDecoder: dailyRewardsDecoder,
  orderRatingRewardsDecoder: orderRatingRewardsDecoder,
  loginHourRewardsDecoder: loginHourRewardsDecoder,
  orderFulfillmentRewardsDecoder: orderFulfillmentRewardsDecoder,
  execute: execute
};

function execute$1(json) {
  return {
          success: Json_decode.field("success", Json_decode.bool, json),
          message: Json_decode.field("message", Json_decode.string, json),
          milestone: Json_decode.optional((function (param) {
                  return Json_decode.field("crossed_milestone", milestoneDecoder, param);
                }), json)
        };
}

var RnrClaim = {
  execute: execute$1
};

function bannerDecoder(json) {
  return {
          name: Json_decode.field("banner_name", Json_decode.string, json),
          url: Json_decode.field("banner_on_click_link", Json_decode.string, json)
        };
}

function execute$2(json) {
  return Json_decode.field("banners", (function (param) {
                return Json_decode.list(bannerDecoder, param);
              }), json);
}

var RnrBanners = {
  bannerDecoder: bannerDecoder,
  execute: execute$2
};

export {
  RnrReport ,
  RnrClaim ,
  RnrBanners ,
  
}
/* DateTime-Catalyst Not a pure module */
